import Vue from "vue";
import Vuelidate from "vuelidate";
import AsyncComputed from "vue-async-computed";
import VueTheMask from "vue-the-mask";
import browserDetect from "vue-browser-detect-plugin";
import { VueReCaptcha } from "vue-recaptcha-v3";

import App from "./App.vue";

import "./stylesheets/uikit.css";
import "./stylesheets/theme.less";
import "./stylesheets/spinner.less";

import { setDefaultBrand, setDefaultLaw } from "./utils/content";

import { useSentry } from "./plugins/sentry";
import { useDatadogRum } from "./plugins/datadog";

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(AsyncComputed);
Vue.use(VueTheMask);
Vue.use(browserDetect);

// find our containing script tag by looking for the data
// attributes we expect to be present on it.
var parent;
document.querySelectorAll("script").forEach(tag => {
  if ("identificationUrl" in tag.dataset) {
    parent = tag;
  }
});

var {
  identificationUrl,
  brand,
  recaptchaSitekey,
  sessionToken,
  theme,
  law,
} = parent.dataset;

Vue.use(VueReCaptcha, {
  siteKey: recaptchaSitekey,
  loaderOptions: {
    useEnterprise: true,
    autoHideBadge: true
  }
});
setDefaultBrand(brand);
setDefaultLaw(law);

if (identificationUrl[0] == "/") {
  identificationUrl = `${document.location.origin}${identificationUrl}`;
}

// also, write a mount point to the DOM
document.write(`<div id="mount-vue-datacompliance"></div>`);

new Vue({
  mounted: () => {
    useSentry()
    useDatadogRum()
  },
  render: h =>
    h(App, {
      props: { identificationUrl, brand, sessionToken, theme, law }
    })
}).$mount("#mount-vue-datacompliance");
